import { BreadCrumbs, HeaderStyled, Title } from 'shared/components/Header/Header.styles';
import styled from 'styled-components';

export const QuestionPageWrapper = styled.div`
  ${({ theme }) => `
    height: 100%;
    ${Title} {
        font-weight: 700;
        margin-bottom: 8px;
    }

    @media screen and (max-width: ${theme.breakpoints.medium}) {
        ${HeaderStyled} {
            margin-bottom: 12px;
        }
        ${BreadCrumbs} {
            margin-bottom: 30px;
        }
        ${Title} {
            font-weight: 500;
        }
    } 
    @media screen and (max-width: ${theme.breakpoints.small}) {
        ${BreadCrumbs} {
            margin-bottom: 26px;
        }
    } 
`}
`;

export default QuestionPageWrapper;
